export default __webpack_public_path__ + "static/media/Red.c5be27bb.mp3";